module.exports = __webpack_public_path__ + "static/media/xvg.f7d3bc42.svg";